import { DatetimePicker } from "@/components/ui/date-time-picker";
import { AirtableDurationHoursFieldOptions } from "@/types/crm/airtable/fields";
import { useEffect, useState } from "react";
import { useFieldContext } from "../../../../../question/components/organisms/FieldRenderer";

// "timescape-fix": "file:../../../../../Documents/GitHub/Praca/timescape/timescape-0.7.0.tgz",

export function DurationHoursRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [date, setDate] = useState<Date | undefined>(new Date());

    useEffect(() => {
        if(currentValue) {
            setDate(new Date(currentValue));
        }
    }, [currentValue]);

    useEffect(() => {
        if (setFormValue) {
            setFormValue(date?.toISOString() || "");
        }
    }, [date, setFormValue]);

    const fieldDateOptions = question.field_date_options as AirtableDurationHoursFieldOptions;
    
    return (
        <div className="">
            {!disabled ? (
                (() => {
                    if (fieldDateOptions.durationFormat === 'h:mm')
                        return (
                            <DatetimePicker
                                value={date}
                                onChange={setDate}
                                format={{
                                    timeFormat: ['hours', 'minutes']
                                }}
                            />
                        )
                    if (fieldDateOptions.durationFormat === 'h:mm:ss')
                        return (
                            <DatetimePicker
                                value={date}
                                onChange={setDate}
                                format={{
                                    timeFormat: ['hours', 'minutes', 'seconds']
                                }}
                            />
                        )
                    return (
                        <DatetimePicker
                            value={date}
                            onChange={setDate}
                            format={{
                                timeFormat: ['hours', 'minutes', 'seconds','milliseconds']
                            }}
                        />
                    )
                })()
            ) : (
                <div className="">
                    {formatTime(new Date(Date.parse(response?.field_value ?? "")), fieldDateOptions.durationFormat)}
                </div>
            )}
        </div>
    )
}

function formatTime(date: Date, durationFormat: AirtableDurationHoursFieldOptions['durationFormat']) {
    switch (durationFormat) {
        case 'h:mm':
            return `${date.getHours()}:${date.getMinutes()}`;
        case 'h:mm:ss':
            return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
        case 'h:mm:ss.s':
        case 'h:mm:ss.ss':
        case 'h:mm:ss.sss':
        default:
            return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    }
}